import styled from 'styled-components'

export const StyledFormItem = styled.div`
  margin-bottom: 1rem;
`

export const Label = styled.p`
  font-size: 90%;
  font-weight: bold;
  margin-bottom: 0.5rem;
`



// WEBPACK FOOTER //
// ./src/components/FormItem/styled.js